<template>
    <div>
       
        <header
            class=""  data-navigation-offset="60px">
          
           
                  
                   

<div fixed="top">
    <div class="topHeader">
        <div class="container">
<div class="row w-100 h-10">
    <div class="col-md-2 col-sm-6">   </div>
    <div class="col-md-2 col-sm-6"> </div>
</div>

        </div>
        
        
        </div> 
    
    <div class="container">
        <div class="row w-100 top-header">
  <div  class="col-md-2 pt-2 col-sm-6" href="#">
      <a class="" href="http://sinaiuniversity.net/"><img
                                    src="./../assets/logo-2.png" alt="" width="137" height="95"
                                     title="logo 2" ><br/>
                                     </a>
                                     </div>
    <div class="col-md-10 " v-if="!showMenu & showMenu != 'undefined'">
<div class="pt-2 text-right float-right userinfo" style="width:80px">
              <span class="b-avatar badge-secondary rounded-circle float-right" style="width: 4rem; height: 4rem;"><span class="b-avatar-img">
                  <img v-if="currenUser.URLPathPhoto" :src="GetPic(currenUser.URLPathPhoto)" alt="avatar">
                  <img v-else src="./../assets/user-profile.png" alt="avatar">
                  </span><!----></span>
<br/><span class=""><a href="#" class="text-bold" @click.prevent="logOut" ><strong>Logout</strong></a></span>

</div>
              
              
          <div class="float-right mt-4">    
        <span class="mr-auto text-blue pt-3">{{currenUser ? currenUser.FirstNameEN : ''}} {{currenUser? currenUser.LastNameEN : ''}}</span><br/>
        <div class=" mr-2 text-orange " v-if="!currenUser.LoginInfo">Logged in As Applicant</div>
        <div class=" mr-2 text-orange" v-else>Logged in As {{currenUser.LoginInfo[0].RoleName}}</div>
       
              </div>
            </div>
            
           
           
</div> 

    <!-- <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

     

           

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto mt-4" right>
        
        <b-nav-item href="/home" active >Home</b-nav-item>
        <b-nav-item href="http://abr.su.edu.eg/" target="_blank">Arish Self-Services</b-nav-item>
        <b-nav-item href="http://www.kbresult.su.edu.eg/Selfservice/Home.aspx" target="_blank">Kantara Self-Services</b-nav-item>
        <b-nav-item href="https://kmoodle.su.edu.eg/" target="_blank">SU LMS</b-nav-item>
        
      </b-navbar-nav>

     
    </b-collapse>   -->
</div>

 
<div class="clearfix"></div>
   
  </div>

              
                  
        
            
        </header>
    </div>






</template>

<script>
//import Newmenu from "../components/Newmenu.vue";
    export default {
        components: {
            //Newmenu,
        },
        name:'Header',
        data(){
            return{
ShowMenu : true,
            }
        },
        methods: {
            logOut() {
         this.$store.dispatch('auth/logout');
         this.$router.push('/login');
    },Menu(){
        this.showMenu
    },
    GetPic(path){
        return "http://unicodesis.su.edu.eg:90"+path
      }
    
    }, computed: {
            currenUser() {
                return this.$store.state.auth.user
            },
            showMenu(){
                 return this.$store.state.auth.Menuhide
            }

        },
        mounted() {
        this.showMenu
        },
    }
</script>

<style scoped>

.text-blue{
    color:#295677;
    font-weight: 800;
    text-align: center;
}
.text-orange{
    color:#ff8600;
    font-weight: 800;
}
.nav-item{
    margin: 5px;
    border: #ff8600 solid 2px;
    border-radius: 10px;
  
}
.nav-link{
      padding-bottom: 10px !important;
}


.top-header{
     min-height: 0px;
}
.badge-secondary {
    color: #fff;
    background-color: #ff8600;
}

.user-Iocn {
    width: 100px;
    height: 100px;
    border-radius: 50% !important;
    border: 1px solid #295677;
    position: relative;
}
.user-Iocn img{
    width: 100%;
}
a {
    color: #295677;
    text-decoration: none;
    background-color: transparent;
}
.topHeader{
    width: 100%;
    background: #295677;
    border-top: 5px solid #FF8600;
   position: relative;
    top: 0;
    color: #fff;
    font-size: 14px;
    height: 25px;
}
.kingster-logo-inner{
    width: 25%;
    float: left;
    
}
.kingster-top-bar{
    background: #295677;
    color: 333;
    padding: 20px;
}
header{
    background: #fff;
   
      width: 100%;
      z-index: 1000;
}

.sf-menu > li {
    float: left;
    cursor: pointer;
    padding-right: 39px;
    padding-top: 30px;
    color: #295677;
    list-style: none;
    float: right;
}
.sf-menu > li a {
    color: #295677;
    font-weight: bold;
}

.sf-menu {
    display: inline-block;
    line-height: 1.7;
    text-align: left;
    margin-bottom: 0px;
    margin-right: 20px;
    float: right;
}
.kingster-header-container {
    position: relative;
    margin-left: auto;
    margin-right: auto;
    width: 90%;
    margin: 0 auto;
}
.h-10{
    height: 30px;
}
@media only screen and (max-width: 1260px){
.kingster-top-bar {
     display:block; 
}
}

.navbar {
    float: right !important;
        color: #295677;
           
    background: #fff;
   
      width: 100%;
      z-index: 1000;
     
      padding: 0px;
     
         
}
.navbar-dark .navbar-nav .nav-link {
     color: #295677;
     font-weight: bold;
      padding-bottom: 44px
}

.navbar-dark .navbar-nav .nav-link:hover {
     color: #295677;
     border-bottom: 5px solid #295677 ;
     border-width: 90%;
     transition: left .3s ease-in-out;
-webkit-transition: left .3s ease-in-out;
transition: left linear 0.25s, right linear 0.25s;
  
     
     
}
.navbar-dark .navbar-nav .nav-link:visited {
     color: #295677 !important;
     border-bottom: 5px solid #295677 ;
     border-width: 90%;
     
     
}
.navbar-dark .navbar-nav .nav-link.active {
     color: #295677 !important;
     border-bottom: 5px solid #295677 ;
     border-width: 90%;
     
     
}
.bg-info {
    background-color: #fff !important;
    border-bottom: 1px solid #dddcdc;
   
}
.navbar-toggler {
    padding: 0.25rem 0.75rem;
    font-size: 1.25rem;
    line-height: 1;
    background-color: #295677;
    border: 1px solid transparent;
    border-radius: 0.25rem;
}
@media (min-width: 1200px){

.container, .container-sm, .container-md, .container-lg, .container-xl {
    max-width: 90% !important;
}
}
@media (max-width: 680px){
.navbar{
    float: right !important;
    color: #295677;
    background: #fff;
    width: 100%;
    z-index: 1000;
   
}

}

@media (max-width: 620px){
.top-header {
    /* min-height: 200px; */
    margin-top: 20px;
    text-align: center;
}
.userinfo{
    width:auto !important
}
}
</style>